document.addEventListener('DOMContentLoaded', function () {
    const specificationOrder = document.querySelector('.specification-order');
    if (specificationOrder) {
        specificationOrder.addEventListener('click', function () {
            const listStore = this.querySelector('.list-store'); // Select the drop-down list
            const headerGroup = document.querySelector('.shopify-section-group-header-group');

            // if the list is already visible, go out
            if (window.getComputedStyle(listStore).display === 'block' && !this.classList.contains('active')) {
                return;
            }

            // Toggle class active on specification-order
            this.classList.toggle('active');

            // Update z-index only when the class active is present
            if (this.classList.contains('active')) {
                headerGroup.style.zIndex = '10';
            } else {
                headerGroup.style.zIndex = ''; // Restore original value
            }
        });
    }
});
